import { defineStore } from "pinia";
import { ROUTE_NAME } from "@/router";
import { request } from "@/api-connectors/basicRequests";

interface ListItemCache {
    locationId: string,
    listId: string,
    itemId: string,
    amount?: number,
    supplierItemId?: string,
    targetStock?: number;
}

export interface PersistentStore {
    apiUrl: string,
    offlineMode: boolean,//RouteLocationNormalizedLoaded | undefined,
    offlineModeRoute?: string,
    offlineCache: {
        deleteItem: ListItemCache[],
        addItem: ListItemCache[],
        patchItem: ListItemCache[]
    };
    introDone: Partial<Record<ROUTE_NAME, boolean>>
    oldTokenChecked: boolean;
    noConnection: boolean;
    legal: {
        impressum: string;
        termsOfUse: string;
        privacyPolicy: string;
    };
    isReducedList: boolean;
}

//store for data that should be persistent/not deleted in any use case inside the app
export const usePersistentStore = defineStore('persistent', {
    state: (): PersistentStore => {
        return {
            apiUrl: '',
            offlineMode: false,
            offlineModeRoute: undefined,
            offlineCache: {
                deleteItem: [],
                addItem: [],
                patchItem: []
            },
            introDone: {},
            oldTokenChecked: false,
            noConnection: false,
            legal: {
                impressum: '',
                privacyPolicy: '',
                termsOfUse: ''
            },
            isReducedList: false
        }
    },
    actions: {
        async getLegal(): Promise<void> {
            const response = await Promise.all([
                request<string>({
                    method: 'GET',
                    route: 'legal/imprint'
                }),
                request<string>({
                    method: 'GET',
                    route: 'legal/termsOfUse'
                }),
                request<string>({
                    method: 'GET',
                    route: 'legal/privacyPolicy'
                })
            ])

            if (response[0]) this.legal.impressum = response[0]
            if (response[1]) this.legal.termsOfUse = response[1]
            if (response[2]) this.legal.privacyPolicy = response[2]
        },

        handleReducedDesign(): void {
            this.isReducedList = !this.isReducedList
        }
    },
    getters: {}
})
